// src/pages/ChatWithAI/components/ToolProgress.js
import React from 'react';
import './ToolProgress.css';

/**
 * @typedef {import('../types/toolTypes').ReasoningStep} ReasoningStep
 */

/**
 * Componente para exibir o progresso de execução de uma tool
 * com seus reasoning steps em tempo real.
 * 
 * @param {Object} props
 * @param {string} props.toolName - Nome da tool
 * @param {Array<ReasoningStep>} props.steps - Steps de raciocínio
 * @param {('executing'|'completed'|'error')} props.status - Status geral da tool
 */
const ToolProgress = ({ toolName, steps = [], status = 'executing' }) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'executing':
        return '⏳';
      case 'completed':
        return '✅';
      case 'error':
        return '❌';
      default:
        return '🔧';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'executing':
        return 'Executando';
      case 'completed':
        return 'Concluído';
      case 'error':
        return 'Erro';
      default:
        return 'Aguardando';
    }
  };

  const getStepIcon = (stepStatus) => {
    switch (stepStatus) {
      case 'pending':
        return '⏸️';
      case 'active':
        return '▶️';
      case 'completed':
        return '✓';
      case 'error':
        return '✗';
      default:
        return '○';
    }
  };

  return (
    <div className={`tool-progress ${status}`}>
      <div className="tool-progress-header">
        <span className="tool-progress-icon">{getStatusIcon()}</span>
        <div className="tool-progress-info">
          <h4 className="tool-progress-name">{toolName}</h4>
          <span className="tool-progress-status">{getStatusText()}</span>
        </div>
      </div>

      {steps.length > 0 && (
        <div className="tool-progress-steps">
          {steps.map((step, index) => (
            <div key={index} className={`progress-step ${step.status}`}>
              <span className="progress-step-icon">{getStepIcon(step.status)}</span>
              <div className="progress-step-content">
                <span className="progress-step-text">{step.step}</span>
                {step.detail && (
                  <span className="progress-step-detail">{step.detail}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ToolProgress;